import { render } from "./DesignTab.vue?vue&type=template&id=344ea89d&scoped=true"
import script from "./DesignTab.vue?vue&type=script&lang=js"
export * from "./DesignTab.vue?vue&type=script&lang=js"

import "./DesignTab.vue?vue&type=style&index=0&id=344ea89d&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344ea89d"]])

export default __exports__